// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1__ZL","cls2":"FocusedNav-cls2__Is FocusedNav-cls1__ZL"};